import { render, staticRenderFns } from "./usersShouxin.vue?vue&type=template&id=a6a0f73c&scoped=true&"
import script from "./usersShouxin.vue?vue&type=script&lang=js&"
export * from "./usersShouxin.vue?vue&type=script&lang=js&"
import style0 from "./usersShouxin.vue?vue&type=style&index=0&id=a6a0f73c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a0f73c",
  null
  
)

export default component.exports